/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 */

import React from 'react';
import { VISIT_ACCENT_COLORS, useVisitStatusLabels } from '../constants/visit-colors';
import type { VisitStatus } from '../constants/visit-colors';
import { Text } from '@/shared/ui';

interface VisitStatusBadgeProps {
  status: VisitStatus;
}

export const VisitStatusBadge: React.FC<VisitStatusBadgeProps> = ({ status }) => {
  const color = VISIT_ACCENT_COLORS[status];
  const statusLabels = useVisitStatusLabels();
  const label = statusLabels[status];

  return (
    <Text
      as="span"
      data-testid="visit-status-badge"
      style={{
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        padding: 'var(--space-1) var(--space-2)',
        paddingLeft: 'var(--space-3)',
        borderRadius: 'var(--radius-sm)',
        fontSize: 'var(--text-meta)',
        fontWeight: 'var(--font-semibold)' as unknown as number,
        background: `${color}28`,
        color: color,
        lineHeight: 1,
      }}
    >
      <Text
        as="span"
        aria-hidden
        style={{
          position: 'absolute',
          left: 'var(--space-1)',
          top: 'var(--space-1)',
          bottom: 'var(--space-1)',
          width: 3,
          borderRadius: 'var(--radius-full)',
          background: color,
          pointerEvents: 'none',
        }}
      />
      {label}
    </Text>
  );
};
